import { Component, Input } from '@angular/core';
import { Product } from '@models/models';

@Component({
	selector: 'discount-view-block',
	template: require('./discount-view-block.component.html'),
	styles: [require('./discount-view-block.component.scss')]
})
export class DiscountViewBlockComponent {
	@Input('negativeItems') negativeItems?: Array<Product>;

	constructor() {}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=kkml25e9zf!./web/modern/components/quotes/common/discount-view-block/discount-view-block.component.ts